import http from './http'
//
/**
 *  @parms resquest 请求地址
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */

const other = `/OtherService`

function getOtherServicePages(params) {
  return http.post(`${other}/getOtherServicePages`, params)
}
function getOtherServiceNumber(params) {
  return http.get(`${other}/getOtherServiceNumber`, params)
}
function getOtherServiceType(params) {
  return http.get(`${other}/getOtherServiceType`, params)
}
function modifyOtherService(params) {
  return http.post(`${other}/modifyOtherService`, params)
}
function delOtherService(params) {
  return http.post(`${other}/delOtherService`, params)
}
function sendOtherService(params) {
  return http.post(`${other}/sendOtherService`, params)
}
function operatOtherService(params) {
  return http.post(`${other}/operatOtherService`, params)
}
function getOtherServiceFileList(params) {
  return http.get(`${other}/getOtherServiceFileList`, params)
}
function delOtherServiceFile(params) {
  return http.get(`${other}/delOtherServiceFile`, params)
}
function updateOtherServiceStatus(params) {
  return http.post(`${other}/updateOtherServiceStatus`, params)
}
function uploadOtherServiceExpenses(params) {
  return http.post(`${other}/uploadOtherServiceExpenses`, params)
}
function uploadAndAuditExpenses(params) {
  return http.post(`${other}/uploadAndAuditExpenses`, params)
}
function getExpensesList(params) {
  return http.post(`${other}/getExpensesList`, params)
}
function deleteExpenses(params) {
  return http.delete(`${other}/deleteExpenses`, params)
}
function confirmServiceExpenses(params) {
  return http.put(`${other}/confirmServiceExpenses`, params)
}

function complete(params) {
  return http.post(`${other}/complete`, params)
}

export {
  getOtherServicePages,
  getOtherServiceNumber,
  getOtherServiceType,
  modifyOtherService,
  delOtherService,
  sendOtherService,
  operatOtherService,
  getOtherServiceFileList,
  updateOtherServiceStatus,
  delOtherServiceFile,
  uploadOtherServiceExpenses,
  getExpensesList,
  uploadAndAuditExpenses,
  deleteExpenses,
  confirmServiceExpenses,
  complete
}
